import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** "Arena" tab of the Lair screen: entry cards to the PvP Arena (/arena) and online Durak (/durak). */
export default function ArenaTab({ onOpen }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="lair-tab">
      <div className="lair-arena-card">
        <div className="lair-arena-card__art" aria-hidden="true">
          <span className="lair-arena-card__vs">VS</span>
        </div>
        <div className="lair-arena-card__title">⚔ {t('lair.arena.title', 'PvP Arena')}</div>
        <div className="lair-arena-card__text">
          {t('lair.arena.text', "Real-time 1v1 duels with your heroes. Move, attack, block and cast your hero's spell — the winner takes the GRAM pot. Free training fights too.")}
        </div>
        <ul className="lair-arena-card__list">
          <li>👊 {t('lair.arena.point_combos', '3-hit combos, 🛡 blocks, ✨ hero magic')}</li>
          <li>💥 {t('lair.arena.point_pickups', 'Barrels and ❤ pickups on the field')}</li>
          <li>💎 {t('lair.arena.point_stakes', 'Stakes in GRAM or free training')}</li>
        </ul>
        <button type="button" className="app-btn app-btn--green" onClick={onOpen}>{t('lair.arena.enter', 'Enter the Arena')}</button>
      </div>
      <div className="lair-arena-card" style={{ marginTop: 12 }}>
        <div className="lair-arena-card__title">🃏 {t('lair.durak.title', 'Durak')}</div>
        <div className="lair-arena-card__text">
          {t('lair.durak.text', "Classic «podkidnoy» Durak 1v1 online. Beat, throw in, don't be the fool — the winner takes the GRAM pot. Free practice tables too.")}
        </div>
        <button type="button" className="app-btn app-btn--purple" onClick={() => navigate('/durak')}>{t('lair.durak.play', 'Play Durak')}</button>
      </div>
    </div>
  );
}
